// extracted by mini-css-extract-plugin
module.exports = {"dialog":"preview-modal_dialog_2tKv4","fullBody":"preview-modal_fullBody_3oaOT"};